import React from 'react';

import SessionLayout from '../layouts/Session/Session';

import LinkedAccountLockedOut from '../components/Session/LinkedAccountFailLockedOut';
import {setPageTitle} from '../utils/helpers';

const LinkedAccountLockedOutContainer = () => {
  setPageTitle('Account locked | Investec Save');

  return (
    <SessionLayout>
      <LinkedAccountLockedOut />
    </SessionLayout>
  );

};

export default LinkedAccountLockedOutContainer;
